export const columnsDataIGP = [
    {
      Header: "PROTEIN",
      accessor: "protein",
    },
    {
      Header: "PEPTIDE",
      accessor: "peptide",
    },
    {
      Header: "GLYCAN",
      accessor: "glycan",
    },
    {
        Header: "BRC",
        accessor: "brc",
      },
      {
        Header: "CCRCC",
        accessor: "ccrcc",
      },
      {
        Header: "CRC",
        accessor: "crc",
      },
      {
        Header: "GBM",
        accessor: "gbm",
      },
      {
        Header: "HNSCC",
        accessor: "hnscc",
      },
      {
        Header: "LSCC",
        accessor: "lscc",
      },
      {
        Header: "LUAD",
        accessor: "luad",
      },
      {
        Header: "OVC",
        accessor: "ovc",
      },
      {
        Header: "PDAC",
        accessor: "pdac",
      },
      {
        Header: "UCEC",
        accessor: "ucec",
      },
    //   {
    //     Header: "SPECTRUM",
    //     accessor: "spectrum",
    //   },
  ];
  